import ReactRailsUJS from "react_ujs";

import { isModernBrowser } from "@shared/polyfill/isModernBrowser/isModernBrowser";
import {
  POLYFILL_SRCS,
  loadPolyfillSrcs,
} from "@shared/polyfill/loadPolyfillSrcs/loadPolyfillSrcs";

ReactRailsUJS.mountComponentsOriginal = ReactRailsUJS.mountComponents;
/* oxlint-disable prefer-arrow-functions/prefer-arrow-functions */
ReactRailsUJS.mountComponents = function (
  ...args: Parameters<typeof ReactRailsUJS.mountComponents>
) {
  const srcs = (window as unknown as Record<string, string[] | undefined>)[POLYFILL_SRCS];

  if (!isModernBrowser()) {
    loadPolyfillSrcs(srcs ?? [], () => {
      ReactRailsUJS.mountComponentsOriginal(...args);
    });
  } else {
    ReactRailsUJS.mountComponentsOriginal(...args);
  }
};

// react_ujs only detects Turbolinks, not @hotwired/turbo; when Turbo is loaded,
// swap its DOMContentLoaded listener for turbo:load so React mounts on visits.
// Turbo frames swap in content without firing turbo:load, so also mount on
// turbo:frame-load (handleMount scopes the mount to the event target frame).
if (typeof window !== "undefined" && "Turbo" in window) {
  ReactRailsUJS.removeEvent!("DOMContentLoaded", ReactRailsUJS.handleMount);
  ReactRailsUJS.handleEvent!("turbo:load", ReactRailsUJS.handleMount);
  ReactRailsUJS.handleEvent!("turbo:frame-load", ReactRailsUJS.handleMount);
}

export default ReactRailsUJS;
